import { render, staticRenderFns } from "./dataIndex.vue?vue&type=template&id=23dfb40e&scoped=true"
import script from "./dataIndex.vue?vue&type=script&lang=ts"
export * from "./dataIndex.vue?vue&type=script&lang=ts"
import style0 from "./dataIndex.vue?vue&type=style&index=0&id=23dfb40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dfb40e",
  null
  
)

export default component.exports